<form [formGroup]="form">
  <div class="p-3 rounded-4 gy-2 bg-gray-200">
    <div class="row align-items-center gy-2">
      <div class="col-12 col-xl-auto col-sm-6">
        <generic-dropdown [items]="noteTypes()" [formControlName]="'noteTypeId'" [required]="true"></generic-dropdown>
      </div>
      <div class="col-xl col-sm-6">
        <textarea
          type="text"
          maxlength="500"
          rows="1"
          class="form-control p-2"
          placeholder="write notes here..."
          formControlName="note"
          name="notes"
        >
        </textarea>
      </div>
      <div class="col-auto ms-auto">
        <div class="d-flex align-items-center gap-2">
          <div class="flex-fill">
            <voice-recorder-widget
              (recordingSaved)="onRecordingSaved($event)"
              [audioUrl]="recordingToUpdate()?.url ?? null"
              [resetRecording]="reset"
              (removeRecording)="removeRecording()"
            ></voice-recorder-widget>
          </div>
          @if (recordingToUpdate() !== null) {
            <button type="button" class="btn btn-h45 btn-shadow" (click)="cancelNotes()">Cancel</button>
          } @else if (!form.invalid) {
            <button
              type="button"
              [ngbTooltip]="'Clear'"
              placement="top"
              class="btn btn-h45 btn-shadow"
              (click)="cancelNotes()"
            >
              <i class="bi bi-arrow-clockwise"></i>
            </button>
          }
          <button
            type="button"
            class="btn btn-h45 btn-primary"
            (click)="saveNotes()"
            [disabled]="form.invalid"
            appBtnLoader="save-notes"
          >
            @if (!recordingToUpdate()) {
              <i class="bi bi-send"></i>
            }
            {{ recordingToUpdate() ? 'Update' : 'Send' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
